import { ConfirmationDialog } from "../../assets/types/common";
import { Constants } from "../../assets/utils/lib/constants";
import { LoadingIndicator } from "../../assets/vfx";
import { VfxDialogProps } from "../../assets/vfx/dialog/vfxDialogProps";
import Drawer from "../../assets/vfx/drawer/drawer";
import { CommunityDto } from "../../services/dto";
import DisplayData from "../common/DisplayData/DisplayData";
import { SettingTypeDto } from "./settingContainer";

interface SettingViewProps<T> {
  data: T | undefined;
  show: boolean;
  communities?: CommunityDto[];
  onHide: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const getCommunityName = (
  communities: CommunityDto[] | undefined,
  communityId?: string
): string =>
  communities?.find((c) => c.id === communityId)?.name ?? Constants.emptyString;

export const SettingView = <T extends SettingTypeDto>(
  props: SettingViewProps<T>
) => {
  let communityName: string = Constants.emptyString;

  if (
    props.communities &&
    props.data &&
    "communityId" in props.data &&
    props.data.communityId
  ) {
    communityName = getCommunityName(props.communities, props.data.communityId);
  }

  const dialogProps: VfxDialogProps | undefined = new ConfirmationDialog().get(
    props.onDelete,
    "Delete",
    {
      Name: props.data?.name ?? Constants.emptyString,
    }
  );

  return (
    <Drawer.View
      className="w-30"
      show={props.show}
      backdrop
      placement="end"
      scroll
      title="View Setting"
      modalDialogProps={dialogProps}
      onHide={props.onHide}
      onEdit={props.onEdit}
      onDelete={props.onDelete}
    >
      {!props.data ? (
        <LoadingIndicator isFullPage />
      ) : (
        <>
          <DisplayData text="Name" importedData={props.data.name} />
          <DisplayData
            text="Description"
            importedData={props.data.description}
          />
          <DisplayData text="Value" importedData={props.data.value} />
          {communityName && (
            <DisplayData text="Community" importedData={communityName} />
          )}
        </>
      )}
    </Drawer.View>
  );
};
